import React, { useEffect } from 'react'

export default function Opstart() {
  useEffect(() => {
    document.title = 'Skolestart | Køreskole i Kalundborg | Tilmeld dig i dag'
    const metaDesc = document.querySelector('meta[name="description"]')
    if (metaDesc) {
      metaDesc.setAttribute(
        'content',
        'Hvornår kan jeg starte? Læs mere om aldersgrænser, forældreunderskrift og lovens minimumskrav til køreundervisning.'
      )
    }
  }, [])

  return (
    <div className="bg-slate-50 min-h-screen py-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white p-8 sm:p-12 border border-slate-200 shadow-sm space-y-8">
          <div>
            <h1 className="font-header text-3xl sm:text-4xl font-extrabold text-slate-900">
              Hvornår kan jeg starte
            </h1>
            <p className="mt-2 text-slate-900 font-bold text-lg">
              Hvad kræves der for at få et kørekort til alm. bil?
            </p>
          </div>

          <div className="space-y-6 text-slate-700 leading-relaxed">
            <ul className="list-disc list-inside space-y-2 text-slate-700">
              <li>
                Man skal være 17 år, før man kan få udstedt kørekort.Du kan starte 3 måneder, før du bliver 17 år.
              </li>
              <li>
                Du må gå op til teoriprøven 1 måned før, du bliver 17 år.
              </li>
              <li>
                Køreprøven må først aflægges på din 17 års fødselsdag.
              </li>
            </ul>

            <p>
              såfremt du ikke er 18 år skal du have begge dine forældres underskrift på at du gerne må tage kørekort, hvis de deler forældremyndigheden over dig
            </p>

            <section className="space-y-3 pt-4 border-t border-slate-200">
              <h2 className="font-header text-2xl font-bold text-slate-900">
                Lovens minimumskrav til undervisning er:
              </h2>
              <ul className="list-disc list-inside space-y-1.5 pl-2 text-slate-800 font-medium">
                <li>29 lektioner i teori</li>
                <li>3 lektioner i lukket øvelsesgård</li>
                <li>17 lektioner på vej</li>
                <li>4 lektioner på glatbane</li>
              </ul>
            </section>

            <section className="space-y-4 pt-4 border-t border-slate-200">
              <h3 className="font-header text-xl font-bold text-slate-900">
                Du skal forvente at bruge flere kørelektioner end loven kræver
              </h3>
              <p>
                Vi følger Færdselsstyrelsens modulplan, og et kørekortforløb er således inddelt i 5 moduler.
              </p>
              <p>
                Ikke alle elever når igennem kørekortforløbet og består teori- eller køreprøven uden at øve sig ud over lovens minimumskrav. Forvent derfor, at du skal øve teoriprøver hjemme og køre ekstra timer.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  )
}
